/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Cards from 'react-credit-cards';
import styled from 'styled-components';
import 'react-credit-cards/es/styles-compiled.css';
import { useForm } from 'react-hook-form';
import { Helmet } from 'react-helmet';
import { saveCardTokenFunction } from '../../database/utils/functions';
import { fireAuth } from '../../database/utils/firebase';
import Txt from '../atoms/Txt';

const Center = styled.div`
  align-self: center;
  margin: 50px;
`;

const Input = styled.input`
  padding: 10px;
  margin: 10px;
`;

const CreateCreditCard = ({ onClose }) => {
  const [error, setError] = useState(null);
  const { register, watch, handleSubmit } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      number: '',
      expiryMonth: '',
      expiryYear: '',
      name: '',
      cvc: ''
    }
  });
  const { number, expiryMonth, expiryYear, name, cvc } = watch();
  const [focus, setFocus] = useState('');
  const [loading, setLoading] = useState(false);
  const expiry = `${expiryMonth}${expiryYear}`;
  const handleFocus = (e) => setFocus(e.target.name);

  const onSubmit = (data) => {
    setError(null);
    setLoading(true);
    console.log('triggering');

    const tempYear = data.expiryYear.length === 2 ? `20${data.expiryYear}` : data.expiryYear;
    const cardData = {
      cardNumber: data.number.replace(/ /g, ''),
      holderName: data.name,
      securityCode: data.cvc,
      expirationMonth: data.expiryMonth,
      expirationYear: tempYear
    };

    try {
      // eslint-disable-next-line no-undef
      const checkout = new DirectCheckout(
        '211610C20F7EB0DAC40748F18D5C2D523E3530425A10BC7496AE63A413038BE0',
        false
      );
      checkout.getCardHash(
        cardData,
        async (cardHash) => {
          try {
            console.log('hash', cardHash);
            await saveCardTokenFunction({
              creditCardHash: cardHash,
              userUID: fireAuth.currentUser.uid
            });
          } catch (error2) {
            console.log(error2);
          }
        },
        (err) => {
          console.log(err);
          setError(err);
        }
      );
    } catch (errorr) {
      console.log(errorr);
    } finally {
      onClose();
      setLoading(false);
    }
    return false;
  };

  return (
    <section>
      <Cards cvc={cvc} expiry={expiry} focused={focus} name={name} number={number} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          {...register('number', { required: true })}
          minLength="16"
          maxLength="19"
          placeholder="Número do cartão"
          onFocus={handleFocus}
        />
        <Input
          name="name"
          {...register('name', { required: true })}
          placeholder="Nome do titular"
          onFocus={handleFocus}
        />

        <Input
          maxLength="2"
          name="expiry"
          {...register('expiryMonth', { required: true })}
          placeholder="Mês de expiração"
          onFocus={handleFocus}
        />

        <Input
          maxLength="4"
          name="expiry"
          {...register('expiryYear', { required: true })}
          placeholder="Ano de expiração"
          onFocus={handleFocus}
        />

        <Input
          name="cvc"
          {...register('cvc', { required: true, minLength: 3, maxLength: 4 })}
          placeholder="CVC"
          onFocus={handleFocus}
        />
        <Input type="submit" value={!loading ? 'Salvar cartão' : 'Processando'} />
        {error && (
          <Center>
            <Txt>Falha ao adicionar o cartão. Verifique as informações.</Txt>
          </Center>
        )}
      </form>
      <Helmet>
        <script
          type="text/javascript"
          src="https://sandbox.boletobancario.com/boletofacil/wro/direct-checkout.min.js"
        />
      </Helmet>
    </section>
  );
};

export default CreateCreditCard;
